"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSubscriptionTier = void 0;
var TeamSubscriptionTier;
(function (TeamSubscriptionTier) {
    TeamSubscriptionTier["UNKNOWN"] = "unknown";
    TeamSubscriptionTier["FREE"] = "free";
    TeamSubscriptionTier["BASIC"] = "basic";
    TeamSubscriptionTier["PREMIUM"] = "premium";
    TeamSubscriptionTier["ULTRA"] = "ultra";
    TeamSubscriptionTier["ORGANIZATION"] = "organization";
})(TeamSubscriptionTier || (exports.TeamSubscriptionTier = TeamSubscriptionTier = {}));
